import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ResumeSystemComponent } from './resume-system.component';
import { MatLegacyCardModule as MatCardModule } from '@angular/material/legacy-card';
import { ComparisonTableSystemModule } from './comparison-table-system/comparison-table-system.module';
import { TransactionCalculatorModule } from '@app/transactions/components/transaction-calculator/transaction-calculator.module';
import { EmptyComponentModule } from '../empty-component/empty-component.module';

@NgModule({
    declarations: [ResumeSystemComponent],
    exports: [ResumeSystemComponent],
    imports: [CommonModule, MatCardModule, ComparisonTableSystemModule, TransactionCalculatorModule, EmptyComponentModule]
})
export class ResumeSystemModule {}
